import { crudResult } from '../../dataContracts';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

const call = async (name, data) => {
  try {
    const fn = httpsCallable(functions, name);
    const result = await fn({ ...data, requestedApp: 'dealership_web' });
    return crudResult(result.data);
  } catch (error) {
    console.error(`Error en ${name}:`, error);
    notifyPermissionDenied(error);
    if (/permission-denied|unauthenticated/.test(error.code || '')) throw error;
    return {
      success: 'no',
      message: `Error en ${name}`,
      error: error.message,
      code: error.code || null,
    };
  }
};

export const listOperatingUnits = (data) =>
  call('listOperatingUnitsV2', data);

// Unidades donde el actor puede invitar miembros (members.invite dentro de su
// alcance administrativo). Fuente de verdad para el selector de sucursal del
// alta de miembros; no depende de units.view.
export const listInvitableUnits = (data) =>
  call('listInvitableUnitsV2', data);

export const getOperatingUnit = (data) =>
  call('getOperatingUnitV2', data);

export const createOperatingUnit = (data) =>
  call('createOperatingUnitV2', data);

export const updateOperatingUnit = (data) =>
  call('updateOperatingUnitV2', data);

export const archiveOperatingUnit = (data) =>
  call('archiveOperatingUnitV2', data);
